import { getSubmissionPreview, } from '@wix/form-submission-preview';
import { useFormViewerContext } from './form-viewer-context';
export const useFormPreview = (formId, values, i18n) => {
    void formId;
    const { controller } = useFormViewerContext();
    const form = controller.wfConfig?.formsById?.[formId];
    if (!form) {
        return undefined;
    }
    return getSubmissionPreview({ form, values, i18n });
};
//# sourceMappingURL=use-form-preview.js.map